import { createContext } from 'react'
import { DateRange } from '@mui/x-date-pickers-pro'
import { Dayjs } from 'dayjs'
import { ContractorStatus } from 'src/constants/contractor/enums'
import {
  ExpirationIndicator,
  ReActivationFilterValue,
  RecollectionFilterValue,
} from 'src/interfaces/contractor'
import { defaultColumnManagerContext, IColumnManagerContext } from 'src/interfaces/columnManager'

export interface IContractorsTableContext extends IColumnManagerContext {
  statusFilter: Array<ContractorStatus>
  setStatusFilter(statusFilter: Array<ContractorStatus>): void

  tagsFilter: Array<string>
  setTagsFilter(tagsFilter: Array<string>): void

  templateFilter: Array<string>
  setTemplateFilter(templateFilter: Array<string>): void

  recollectionFilter: Array<RecollectionFilterValue>
  setRecollectionFilter(recollectionFilter: Array<RecollectionFilterValue>): void

  expirationIndicatorFilter: Array<ExpirationIndicator>
  setExpirationIndicatorFilter(expirationIndicatorFilter: Array<ExpirationIndicator>): void

  vehicleTypeFilter: Array<string>
  setVehicleTypeFilter(vehicleTypeFilter: Array<string>): void

  reActivationFilter: Array<ReActivationFilterValue>
  setReActivationFilter(reActivationFilter: Array<ReActivationFilterValue>): void

  dateOnboardedRange: DateRange<Dayjs>
  setDateOnboardedRange(dateOnboardedRange: DateRange<Dayjs>): void

  refreshContractors(): Promise<void>
}

export const ContractorsTableContext = createContext<IContractorsTableContext>({
  ...defaultColumnManagerContext,

  statusFilter: [],
  setStatusFilter: () => {},

  tagsFilter: [],
  setTagsFilter: () => {},

  templateFilter: [],
  setTemplateFilter: () => {},

  recollectionFilter: [],
  setRecollectionFilter: () => {},

  expirationIndicatorFilter: [],
  setExpirationIndicatorFilter: () => {},

  vehicleTypeFilter: [],
  setVehicleTypeFilter: () => {},

  reActivationFilter: [],
  setReActivationFilter: () => {},

  dateOnboardedRange: [null, null],
  setDateOnboardedRange: () => {},

  refreshContractors: async () => {},
})
